import type { AnalyticsKpis } from '../../hooks/useEstoqueAnalytics'

interface Props {
  breakdown: AnalyticsKpis['abcBreakdown']
}

const CURVE_COLORS = {
  A: { bar: 'bg-emerald-500', text: 'text-emerald-700 dark:text-emerald-300', label: 'Curva A · 80% do valor' },
  B: { bar: 'bg-sky-500',     text: 'text-sky-700 dark:text-sky-300',         label: 'Curva B · próximos 15%' },
  C: { bar: 'bg-gray-500',    text: 'text-ink-muted',                         label: 'Curva C · 5% restantes' },
} as const

export default function AbcChart({ breakdown }: Props) {
  const totalSkus = breakdown.A.count + breakdown.B.count + breakdown.C.count
  const totalValue = breakdown.A.value + breakdown.B.value + breakdown.C.value

  return (
    <div className="bg-surface border border-line rounded-xl p-5">
      <h3 className="text-sm font-semibold text-ink mb-4">Curva ABC</h3>
      {totalSkus === 0 ? (
        <p className="text-sm text-ink-faint">Sem dados — recalcule os indicadores.</p>
      ) : (
        <div className="space-y-4">
          {(['A', 'B', 'C'] as const).map(k => {
            const skuPct = totalSkus > 0 ? (breakdown[k].count / totalSkus) * 100 : 0
            const valPct = totalValue > 0 ? (breakdown[k].value / totalValue) * 100 : 0
            const c = CURVE_COLORS[k]
            return (
              <div key={k}>
                <div className="flex justify-between text-xs mb-1">
                  <span className={`font-medium ${c.text}`}>{c.label}</span>
                  <span className="text-ink-muted tabular-nums">
                    {breakdown[k].count} SKUs · {valPct.toFixed(1)}% valor
                  </span>
                </div>
                <div className="flex gap-1 h-3">
                  <div className="flex-1 bg-sunken rounded overflow-hidden" title={`${skuPct.toFixed(1)}% dos SKUs`}>
                    <div className={`h-full ${c.bar} opacity-60`} style={{ width: `${skuPct}%` }} />
                  </div>
                  <div className="flex-1 bg-sunken rounded overflow-hidden" title={`${valPct.toFixed(1)}% do valor`}>
                    <div className={`h-full ${c.bar}`} style={{ width: `${valPct}%` }} />
                  </div>
                </div>
              </div>
            )
          })}
          <div className="flex gap-1 text-[10px] text-ink-faint pt-1">
            <span className="flex-1 text-center">% de SKUs</span>
            <span className="flex-1 text-center">% do valor</span>
          </div>
        </div>
      )}
    </div>
  )
}
